/*
 * Automatisch doorschuiven van horizontale productlijsten.
 *
 * Werkt op elk element dat horizontaal scrolt en het attribuut
 * data-collett-autoscroll draagt. De waarde is het aantal seconden tussen twee
 * stappen; leeg betekent zeven.
 *
 * Drie regels die het rustig houden:
 *
 * 1. Alleen schuiven als de lijst in beeld is. Een carrousel die onderaan de
 *    pagina staat en al drie keer is doorgeschoven voordat je hem ziet, mist
 *    zijn doel.
 * 2. Stoppen zodra de bezoeker zelf iets doet, en pas na een pauze weer
 *    beginnen. Wie zelf aan het kijken is moet niet onder zijn handen worden
 *    weggescrold.
 * 3. Niets doen als het systeem om minder beweging vraagt.
 */

(() => {
  const PAUZE_NA_INTERACTIE = 20000;

  const minderBeweging = window.matchMedia('(prefers-reduced-motion: reduce)');

  const stapBreedte = (lijst) => {
    const eerste = lijst.firstElementChild;
    if (!eerste) return lijst.clientWidth;

    const breedte = eerste.getBoundingClientRect().width;
    const gat = parseFloat(getComputedStyle(lijst).columnGap) || 0;
    return Math.round(breedte + gat) || lijst.clientWidth;
  };

  // Zichtbaarheid meten we bij elke tik in plaats van met een
  // IntersectionObserver. Die bleek niet overal te vuren, en een carrousel die
  // niet beweegt is erger dan een rekensommetje van niks.
  const inBeeld = (el) => {
    const r = el.getBoundingClientRect();
    if (r.height === 0) return false;
    const zichtbaar = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
    return zichtbaar / r.height > 0.3;
  };

  const start = (lijst) => {
    const seconden = parseFloat(lijst.dataset.collettAutoscroll) || 7;
    let geblokkeerdTot = 0;
    let muisErop = false;

    const stap = () => {
      if (muisErop || Date.now() < geblokkeerdTot) return;
      if (minderBeweging.matches) return;
      if (!inBeeld(lijst)) return;

      const eind = lijst.scrollWidth - lijst.clientWidth;
      if (eind <= 1) return;

      // Aan het eind terug naar het begin, zodat het een rondje blijft.
      const doel = lijst.scrollLeft >= eind - 2 ? 0 : lijst.scrollLeft + stapBreedte(lijst);
      lijst.scrollTo({ left: doel, behavior: 'smooth' });
    };

    setInterval(stap, seconden * 1000);

    // Zelf schuiven, slepen of klikken pauzeert een tijdje. Alleen met de muis
    // erboven hangen pauzeert zolang je er hangt: wie leest wil niet dat het
    // onder zijn ogen wegschuift, maar hoeft daarna ook niet te wachten.
    const onderbreek = () => {
      geblokkeerdTot = Date.now() + PAUZE_NA_INTERACTIE;
    };

    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach((soort) => {
      lijst.addEventListener(soort, onderbreek, { passive: true });
    });

    lijst.addEventListener('mouseenter', () => { muisErop = true; });
    lijst.addEventListener('mouseleave', () => { muisErop = false; });
  };

  const init = () => {
    document.querySelectorAll('[data-collett-autoscroll]').forEach((lijst) => {
      if (lijst.dataset.collettAutoscrollActief === '1') return;
      lijst.dataset.collettAutoscrollActief = '1';
      start(lijst);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Secties die via de Section Rendering API opnieuw geladen worden.
  document.addEventListener('shopify:section:load', init);
})();
